import Link from 'gatsby-link';
import React from 'react';

export default ({ participants }) =>
  <div>
    {participants.map(participant =>
      <div className="list-item" key={participant.permalink}>
        <strong className="emphasized">
          {participant.name}
        </strong>

        <div dangerouslySetInnerHTML={{ __html: participant.fields.textHtml }}/>

        <Link to={participant.website}>
          {participant.website}
        </Link>
      </div>
    )}
  </div>
;

export const fragments = graphql`
  fragment ParticipantListingFields on ParticipantsYaml {
    fields {
      textHtml
    }
    name
    website
  }
`;



// WEBPACK FOOTER //
// ./src/components/participant-listing.js